import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import theme, { version } from '@resultadosdigitais/tangram-design-tokens';
import ThemeContext from './ThemeContext';
import { DesignTokens } from '../StyleBase';

var _ref2 =
/*#__PURE__*/
React.createElement(DesignTokens, null);

var Theme =
/*#__PURE__*/
forwardRef(function (_ref, ref) {
  var children = _ref.children,
      as = _ref.as,
      value = _ref.value,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "as", "value"]);

  var context = {
    tokens: theme(value),
    version: "v".concat(version),
    kind: value
  };
  var resolvedChildren =
  /*#__PURE__*/
  React.createElement(ThemeContext.Provider, {
    value: context
  }, _ref2, children);
  return (
    /*#__PURE__*/
    React.createElement(as, _extends({
      ref: ref,
      'data-tangram-design-tokens': context.version,
      'data-tangram-theme': context.kind
    }, rest), resolvedChildren)
  );
});
Theme.kinds = {
  lina: 'lina',
  crm: 'crm',
  marketing: 'marketing'
};
Theme.displayName = 'Theme';
Theme.defaultProps = {
  as: 'div',
  value: Theme.kinds.marketing,
  children: null
};
process.env.NODE_ENV !== "production" ? Theme.propTypes = {
  as: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.string, PropTypes.shape({
    render: PropTypes.func.isRequired
  })]),
  value: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.string, PropTypes.array])
} : void 0;
export default Theme;